// src/components/SignupPage.js
/**
 * Public landing page shown to unauthenticated visitors.
 * Flow: user types an email → we sign-in anonymously → store email on their profile
 * → send them into onboarding. Later they'll "Create an account" to set a password.
 */

import { useTranslation } from "react-i18next";

import HeroBackground from "../components/HeroBackground";
import SignUp from "../components/authentication/SignUp";

export default function SignupPage() {
  const { t, i18n } = useTranslation();

  return (
    <div className="w-full lg:w-2/3 h-full flex flex-col justify-between lg:justify-center items-center gap-4 text-greyscale-1">
      <HeroBackground
        poster="/brand/CoverHero.png"
        videoSrc="/brand/HeroVideo.mp4"
      />
      <div className="flex flex-col items-center justify-center z-10 h-fit w-full">
        <img
          src="/logos/BreatheUltra_Main_Logo.png"
          className="w-2/3 h-auto max-w-lg"
          alt="PDX logo"
        />
      </div>
      <div className="flex flex-col gap-2 p-4 w-full  items-center justify-between max-w-lg relative bg-container rounded-t-2xl lg:rounded-2xl">
        {/* <h1 className="supertitle-text !text-primary">
          <span>{t("landing.title")}</span>
        </h1> */}
        <h2 className="title-text">{t("landing.subtitle")}</h2>

        <SignUp showCodeField />
      </div>{" "}
    </div>
  );
}
